import { ChevronLeft, ChevronRight } from "lucide-react";
import { L } from "@/i18n";

export const Pager = ({ page, pages, total, from, to, onPage, prefix = "users" }) => (
  <div className="flex items-center justify-between gap-4 px-5 py-4 border-t border-[#1e293b] text-xs text-slate-400" data-testid={`${prefix}-pager`}>
    <span data-testid={`${prefix}-result-count`}>{total ? L("{f}–{t} of {n}", "{f}–{t} de {n}", { f: from, t: to, n: total }) : L("0 results", "0 resultados")}</span>
    <div className="flex items-center gap-2">
      <button disabled={page <= 1} onClick={() => onPage(page - 1)} className="p-1.5 rounded-md border border-slate-700 disabled:opacity-40 hover:border-amber-500/50 hover:text-amber-400 transition-colors" data-testid={`${prefix}-prev-page`} aria-label={L("Previous", "Anterior")}>
        <ChevronLeft className="h-4 w-4" />
      </button>
      <span className="font-mono">{page}/{pages}</span>
      <button disabled={page >= pages} onClick={() => onPage(page + 1)} className="p-1.5 rounded-md border border-slate-700 disabled:opacity-40 hover:border-amber-500/50 hover:text-amber-400 transition-colors" data-testid={`${prefix}-next-page`} aria-label={L("Next", "Seguinte")}>
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  </div>
);
